import { css } from '@emotion/react'

const base = theme => css`
  li {
    & + li {
      margin-top: 8px;
    }
    button {
      width: 100%;
      color: ${theme.color.monochrome.black};
      font-size: ${theme.fontSize.large};
      letter-spacing: 0;
      line-height: 1.714;
      justify-content: flex-start;
      box-shadow: 0 1px 4px 0 rgba(${theme.color.monochrome.black_rgba}, 0.05);

      &:hover {
        border-color: ${theme.color.buttonPrimary.borderHover};
      }

      &:active {
        border-color: ${theme.color.buttonPrimary.borderPressed};
      }

      svg {
        color: ${theme.color.monochrome.dark};

        & + span {
          margin-left: 11px;
        }
      }
    }
  }
`

export const styles = {
  base,
}
